import { useAccount, useConnect, useDisconnect } from "wagmi";
import { injected } from "wagmi/connectors";

function WalletConnect() {
  const { address, isConnected } = useAccount();
  const { connect } = useConnect();
  const { disconnect } = useDisconnect();

  if (isConnected)
    return (
      <div className="component-card">
        <div style={{ marginBottom: 8 }}>Connected Wallet: {address}</div>
        <button className="component-btn" onClick={() => disconnect()}>Disconnect</button>
      </div>
    );

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
      <button className="component-btn" onClick={() => connect({ connector: injected() })}>Connect Wallet</button>
    </div>
  );
}

export default WalletConnect;
